import { fontWeightBold } from '@/constants'
import { faBasketShopping } from '@fortawesome/pro-light-svg-icons'
import { Typography } from '@mui/material'

import type { NotificationTemplateProps } from '../NotificationCard.templates'
import { NotificationAction } from '../NotificationCard.utils'
import NotificationShell from '../NotificationShell'

export default function BasketAnalyzedNotification({
	notification,
	variant,
	type,
	onAction = () => {},
	onClose,
	onToggleRead,
	...rest
}: NotificationTemplateProps) {
	return (
		<NotificationShell
			icon={faBasketShopping}
			notification={notification}
			variant={variant}
			onClose={onClose}
			onToggleRead={onToggleRead}
			{...rest}
		>
			<Typography variant="body1" color="primary" fontWeight={fontWeightBold}>
				{notification.title}
			</Typography>

			{notification.actions.map((action) => (
				<NotificationAction
					key={JSON.stringify(action)}
					notification={notification}
					action={action}
					onAction={onAction}
				/>
			))}
		</NotificationShell>
	)
}
